export const STORE_CATEGORY_OPTIONS = [
  '美食',
  '甜点饮品',
  '超市便利',
  '蔬菜水果',
  '看病买药',
] as const

export type StoreCategory = typeof STORE_CATEGORY_OPTIONS[number]
